(function () {
  'use strict';

  angular.module('app').component('outgoingPrepaymentList', outgoingPrepaymentList());

  function outgoingPrepaymentList() {
    return {
      bindings: {
        item: '<',
        outgoingPrepayments: '<',
        company: '<',
      },
      controller: outgoingPrepaymentListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/prepayment-reports/outgoing-prepayments/outgoing-prepayment-list/' +
        'outgoing-prepayment-list.component.html',
    };
  }

  outgoingPrepaymentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'OutgoingPrepaymentService',
    'PaymentProviderService',
  ];

  function outgoingPrepaymentListComponent(
    config,
    UtilService,
    $translate,
    $filter,
    OutgoingPrepaymentService,
    PaymentProviderService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);
    vm.filterCriteria = OutgoingPrepaymentService.getFilterCriteria();
    vm.dateDisplay = config.DATE_DISPLAY;

    // private properties
    // -----------------------
    $translate = $filter('translate');

    // public methods
    // -----------------------
    vm.setItemPaymentDocumentsProvider = function (item) {
      let balance = 0;
      let totalPrice = item.total_price; // extra prices ??????
      vm.totalAmountReceived = 0;

      if (vm.providerPaymentDocuments != null) {
        vm.providerPaymentDocuments.forEach(function (paymentDocument) {
          paymentDocument.payment_method = vm.UtilService.findItemInArray(
            vm.company.payment_methods,
            'code',
            paymentDocument.received_payment.payment_method_code
          );

          balance = parseFloat(totalPrice) - parseFloat(paymentDocument.amount);
          totalPrice = balance;

          paymentDocument.balance = balance;

          vm.totalAmountReceived += parseFloat(paymentDocument.amount);
        });

        vm.totalOutstandingBalance =
          parseFloat(item.total_price) - parseFloat(vm.totalAmountReceived);
      }
    };

    vm.openPaymentProviderModal = function (outgoingPrepayment) {
      let paymentProvider = {
        currency_id: vm.item.currency.id,
        provider_id: outgoingPrepayment.provider.id,
        provider: outgoingPrepayment.provider,
        currency: vm.item.currency,
        user_id: vm.item.user_id,
        amount: outgoingPrepayment.balance_due,

        payment_provider_document: {
          document_date: outgoingPrepayment.due_date,
          document_id: outgoingPrepayment.id,
          payment_date: outgoingPrepayment.due_date,
          total_price: outgoingPrepayment.amount,
          newBalance: 0,
          balance: outgoingPrepayment.balance_due,
          number: outgoingPrepayment.outgoing_consecutive,
          amount: outgoingPrepayment.balance_due,
          type: 'outgoing_prepayment',
        },
      };

      let successCallback = function () {
        getPrepayments();
        vm.UtilService.itemListChanged(outgoingPrepayment.id);
      };

      PaymentProviderService.openItemPaymentProviderModal(
        paymentProvider,
        'create',
        vm.company,
        paymentProvider,
        successCallback
      );
    };

    vm.saveOutgoingPrepaymentItem = function (outgoingPrepayment) {
      vm.formErrors = false;

      if (validatePercentage()) {
        vm.serverErrors = vm.UtilService._errorMsg($translate('REACH_TOTAL_PERCENTAGE'));
        vm.formErrors = true;

        return;
      }

      outgoingPrepayment.total_price = vm.item.total_price;
      outgoingPrepayment.amount =
        (outgoingPrepayment.percentage / 100) * outgoingPrepayment.total_price;

      outgoingPrepayment.balance_due = vm.UtilService.roundNum(
        outgoingPrepayment.amount - outgoingPrepayment.receivedAmount
      );

      OutgoingPrepaymentService.saveOutgoingPrepayment(outgoingPrepayment).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          outgoingPrepayment.editItem = false;

          vm.UtilService.itemListChanged(response.id);
          getPrepayments('edit');
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.openRelatedTransactions = function (outgoingPrepayment) {
      OutgoingPrepaymentService.openRelatedTransactions(outgoingPrepayment);
    };

    vm.editOutgoingPrepayment = function (outgoingPrepayments) {
      if (!validateEditDelete(outgoingPrepayments, 'edit')) {
        return;
      } else {
        outgoingPrepayments.editItem = true;
      }
    };

    vm.closeEdit = function (outgoingPrepayments, index) {
      outgoingPrepayments.editItem = false;
      setOutgoingPrepayment(index);
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      getPrepayments();
    };

    vm.sortByProvider = function () {
      vm.outgoingPrepayments = vm.outgoingPrepayments.sort((a, b) => {
        vm.asc = !vm.asc;
        if (vm.asc) {
          return a.provider.commercial_name < b.provider.commercial_name ? -1 : 1;
        } else {
          return a.provider.commercial_name < b.provider.commercial_name ? 1 : -1;
        }
      });
    };

    vm.$onInit = function () {
      vm.originalItems = angular.copy(vm.outgoingPrepayments);
      setOutgoingPrepaymentTotals('get');
    };

    function getPrepayments(mode = 'get') {
      vm.filterCriteria.by_booking_id = vm.item.id;
      vm.filterCriteria.sortedBy = vm.filterCriteria.sortedBy || 'outgoing_consecutive';

      OutgoingPrepaymentService.getPrepayments(vm.filterCriteria).then(function (data) {
        vm.originalItems = angular.copy(data.items);

        if (mode === 'get') vm.outgoingPrepayments = data.items;

        setOutgoingPrepaymentTotals(mode === 'get' ? 'sum' : 'edit');
      });
    }

    function setOutgoingPrepaymentTotals(type) {
      if (!vm.outgoingPrepayments) return;

      let totalCost = vm.item.total_cost;
      vm.totalPaymentReceived = 0;
      vm.totalOutstandingBalance = 0;
      vm.totalPercentage = 0;
      vm.totalAmount = 0;
      vm.totalBalance = 0;

      vm.outgoingPrepayments.forEach(function (outgoingPrepayment) {
        outgoingPrepayment.company_id = vm.company.id;

        outgoingPrepayment.receivedAmount = outgoingPrepayment.payment_provider_documents.reduce(
          (totalAmount, document) => {
            return totalAmount + document.amount;
          },
          0
        );

        outgoingPrepayment.balance_due = outgoingPrepayment.balance_due || 0;

        if (type === 'sum') outgoingPrepayment.editItem = false;

        vm.totalPaymentReceived += vm.UtilService.roundNum(outgoingPrepayment.receivedAmount);
        vm.totalBalance += vm.UtilService.roundNum(outgoingPrepayment.balance_due);
        vm.totalAmount += vm.UtilService.roundNum(outgoingPrepayment.amount);
        vm.totalPercentage += vm.UtilService.roundNum(outgoingPrepayment.percentage);
      });

      vm.totalOutstandingBalance = vm.UtilService.roundNum(totalCost - vm.totalPaymentReceived);
    }

    function validateEditDelete(outgoingPrepayments, type) {
      let cannotEdit = false;
      let modalParams = {
        title: 'WARNING',
        body: null,
      };

      if (vm.item.status === 'closed') {
        cannotEdit = true;
        modalParams.body =
          type === 'edit' ? 'EDIT_PREPAYMENT_BOOKING_CLOSED' : 'DELETE_PREPAYMENT_BOOKING_CLOSED';
      } else if (outgoingPrepayments.status === 'completed') {
        cannotEdit = true;
        modalParams.body = type === 'edit' ? 'EDIT_PREPAYMENT_PENDING' : 'DELETE_PREPAYMENT_EDIT';
      }

      if (cannotEdit) vm.UtilService.warningMsg(modalParams, null, null);

      return !cannotEdit;
    }

    function setOutgoingPrepayment(index) {
      vm.outgoingPrepayments[index] = angular.copy(vm.originalItems[index]);
      setOutgoingPrepaymentTotals('edit');
    }

    function validatePercentage() {
      return vm.outgoingPrepayments.reduce(
        (totalPercentage, prepayment) => totalPercentage + prepayment.percentage,
        0
      );
    }
  }
})();
